module.exports = __webpack_public_path__ + "static/media/local-central@3x.51f1e4fd.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/information/venues-and-open-hours/img/local-central@3x.png
// module id = 1178
// module chunks = 2